import { useState, useEffect } from 'react'
import { Link } from '@tanstack/react-router'
import './Header.css'
// import type React from 'react'

export function Header() {
  const [scrolled, setScrolled] = useState(false)

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20)
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  // const scrollToContact = (e: React.MouseEvent) => {
  //   e.preventDefault()
  //   document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })
  // }

  return (
    <header className={`header${scrolled ? ' header--scrolled' : ''}`}>
      <div className="header__inner container">

        <Link to="/" className="header__logo">
          <svg className="header__logo-icon" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M4 16L12 8V12H20V8L28 16L20 24V20H12V24L4 16Z" fill="currentColor"/>
          </svg>
          <span className="header__logo-text">
            <span className="header__logo-name">Adaptive Web Solutions</span>
            <span className="header__logo-sub">Adapt. Overcome. Evolve.</span>
          </span>
        </Link>
        {/* <div className="footer__brand">
          <a href="#" onClick={scrollToTop} className="footer__logo">
            <svg viewBox="0 0 32 32" fill="none" aria-hidden="true">
              <path d="M4 16L12 8V12H20V8L28 16L20 24V20H12V24L4 16Z" fill="currentColor"/>
            </svg>
            <span>Adaptive Web Solutions</span>
          </a>
          <p className="footer__tagline">
            Adapt. Overcome. Evolve.
          </p>
        </div> */}

        <nav className="header__nav" aria-label="Primary">
          <Link to="/" className="header__nav-link" activeProps={{ className: 'header__nav-link--active' }}>
            Home
          </Link>
          <Link to="/linkwatch" className="header__nav-link" activeProps={{ className: 'header__nav-link--active' }}>
            LinkWatch
          </Link>
          <a href="/#contact" className='header__nav-link'>Contact</a>
          {/* <Link to="/#contact" className="header__nav-link" activeProps={{ className: 'header__nav-link--active' }}>
            Contact
          </Link> */}
        </nav>

        {/* <span className="header__motto" aria-label="Company motto">
          <Link to="/linkwatch" className="header__nav-link" activeProps={{ className: 'header__nav-link--active' }}>
            LinkWatch
          </Link>
        </span> */}

        {/* <a href="#contact" className="btn btn--primary header__cta" onClick={scrollToContact}>
          Get In Touch
        </a> */}

      </div>
    </header>
  )
}
